<!-- (1.7.10) 予約確認メール送信モーダル -->
<form [formGroup]="formGroup">
  <div class="l-modal02__contents u-modal-size-pc-600 js-modal-contents" aria-modal="true" aria-labelledby="modalTitle">
    <div class="l-modal02__header js-modal-head">
      <!-- モーダルヘッダーが入ります -->
      <div class="p-modal-head02">
        <h1 id="modalTitle" class="p-modal-head02__title">{{ 'label.eMail' | staticMsg }}</h1>
        <button class="p-modal-head02__close js-modal-close" (click)="closeModal()" id="close-share-email-btn">
          <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
        </button>
      </div>
      <!-- //モーダルヘッダーが入ります -->
    </div>

    <div class="l-modal02__body js-modal-body">
      <!-- モーダルの中身が入ります -->

      <div class="p-modal-body07">
        <div class="p-modal-enter-email">
          <div class="p-modal-enter-email__row">
            <div class="p-modal-enter-email__row-box p-modal-enter-email__row-box--w345">
              <div class="c-form-element-input">
                <!-- (1.7.12) 予約確認メール送信モーダル.予約確認メール送信先アドレス -->
                <asw-input
                  id="email"
                  [label]="'label.eMailAddress' | staticMsg"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  [attr.aria-label]="'reader.eMailAddress' | staticMsg"
                  disablePaste
                  [conversionType]="'email'"
                  formControlName="email"
                >
                </asw-input>
              </div>
            </div>
          </div>
          <div class="p-modal-enter-email__row">
            <div class="p-modal-enter-email__row-box p-modal-enter-email__row-box--w345">
              <div class="c-form-element-input">
                <!-- (1.7.12) 予約確認メール送信モーダル.予約確認メール送信先アドレス(確認用) -->
                <asw-input
                  id="emailConfirm"
                  [label]="'label.confirmMailAddress' | staticMsg"
                  [placeholder]="'placeholder.eMailAddress' | staticMsg"
                  [attr.aria-label]="'reader.confirmMailAddress' | staticMsg"
                  [conversionType]="'email'"
                  disablePaste
                  formControlName="emailConfirm"
                ></asw-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- //モーダルの中身が入ります -->
    </div>

    <div class="l-modal02__footer js-modal-footer">
      <!-- モーダルフッターが入ります -->
      <div class="p-modal-foot01">
        <button
          class="c-btn-primary c-btn-primary--s c-btn-primary--wide"
          id="btn-share-email"
          (click)="clickShareEmail()"
        >
          <span class="c-btn-primary__text" [innerHTML]="'label.send' | staticMsg">Share</span>
        </button>
      </div>
      <!-- //モーダルフッターが入ります -->
    </div>
  </div>
</form>
